import CatalogTransferWizardHeader from '@Scenes/RightsholderScene/CatalogTransfer/CatalogTransferWizard/CatalogTransferWizardHeader'
import React, { useContext } from 'react'
import Button from '@Components/Buttons/Button'
import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'
import './index.scss'

const ConfirmationStep = () => {
    const { rightsholderStore } = useContext(StoresContext)

    return (
        <div className="ct-confirm-step ct-wizard-step-container">
            <CatalogTransferWizardHeader title="Catalog Transfer Request Submitted">
                <p>
                    We're processing your catalog transfer request. Your catalog transfer documents will now be
                    forwarded to the existing claimant for their formal relinquishment.
                </p>
            </CatalogTransferWizardHeader>
            <div className="ct-confirm-step-actions">
                <Button
                    mainColor
                    type="secondary"
                    typeLink
                    linkTo={Navigation.rightholder.catalogTransfer.wizardLanding(
                        rightsholderStore.currentRightsholderId
                    )}
                >
                    Submit New Transfer
                </Button>
                <Button
                    mainColor
                    type="primary"
                    typeLink
                    linkTo={Navigation.rightholder.catalogTransfer.root(rightsholderStore.currentRightsholderId)}
                >
                    Done
                </Button>
            </div>
        </div>
    )
}

export default ConfirmationStep
